import React, { useState } from 'react';
import {
    Box,
    Chip,
    Menu,
    FormControl,
    Input,
    FormHelperText,
    InputAdornment,
    Grid,
} from '@mui/material';
import { trakrefFontFamilySemiBold } from '../../../utils';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';

const chipStyle = {
    '&.MuiChip-root': { borderRadius: 0, backgroundColor: '#fff', border: '1px solid #E3E8EB' },
    '&.MuiChip-label': { fontFamily: trakrefFontFamilySemiBold }
};

const formControlStyle = { width: 'auto' };

const ChipRangeInput = ({
    id,
    disabled,
    label,
    minRangeValue,
    maxRangeValue,
    minRangeOnChange,
    maxRangeOnChange,
    minRangeHelperText,
    maxRangeHelperText,
    abbreviation,
    deletable,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const determineLabel = () => {
        let customLabel = label;

        if (minRangeValue) {
            customLabel += `: ${minRangeValue}${abbreviation} - `
        }

        if (maxRangeValue) {
            customLabel += `${maxRangeValue}${abbreviation}`;
        }
        return customLabel;
    };

    const clearRange = () => {
        minRangeOnChange("");
        maxRangeOnChange("");
    };
    
    const chipLabel = determineLabel();

    return (
        <>
            <Chip
                label={chipLabel}
                onClick={(e) => setAnchorEl(e.currentTarget)}
                onDelete={(e) => deletable && (minRangeValue || maxRangeValue) ? clearRange() : setAnchorEl(e.currentTarget)}
                deleteIcon={deletable && (minRangeValue || maxRangeValue) ? <CloseIcon /> : <KeyboardArrowDownIcon />}
                variant="outlined"
                disabled={disabled}
                id={id}
                sx={{...chipStyle}}
            />
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                PaperProps={{  
                    style: {
                        width: 'auto',
                        height: 'auto',
                        maxHeight: 300,
                    }
                }}
            >
                <Box sx={{ p: 2, width: 300 }}>
                    <Grid container justifyContent="center" spacing={2}>
                        <Grid item xs={6}>
                            <FormControl variant="standard" sx={formControlStyle}>
                                <Input
                                    value={minRangeValue}
                                    id={id}
                                    endAdornment={<InputAdornment position="end">{abbreviation}</InputAdornment>}
                                    aria-describedby="range-input-text"
                                    onChange={e => minRangeOnChange(e.target.value)}
                                    disabled={disabled}
                                />
                                <FormHelperText>{minRangeHelperText}</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl variant="standard" sx={formControlStyle}>
                                <Input
                                    value={maxRangeValue}
                                    id={id}
                                    endAdornment={<InputAdornment position="end">{abbreviation}</InputAdornment>}
                                    aria-describedby="range-input-text"
                                    onChange={e => maxRangeOnChange(e.target.value)}
                                    disabled={disabled}
                                />
                                <FormHelperText>{maxRangeHelperText}</FormHelperText>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>
            </Menu>
        </>
    );
};

ChipRangeInput.propTypes = {
    label: PropTypes.string.isRequired,
    minRangeValue: PropTypes.string.isRequired,
    maxRangeValue: PropTypes.string.isRequired,
    minRangeOnChange: PropTypes.func.isRequired,
    maxRangeOnChange: PropTypes.func.isRequired,
    minRangeHelperText: PropTypes.string,
    maxRangeHelperText: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    abbreviation: PropTypes.string,
    deletable: PropTypes.bool,
};

ChipRangeInput.defaultProps = {
    required: false,
    disabled: false,
    id: "",
    abbreviation: "",
    minRangeHelperText: "",
    maxRangeHelperText: "",
    deletable: false,
};

export default ChipRangeInput;